/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useFormik } from "formik";
import clsx from "clsx";
import { useState } from "react";
import { useAuth } from "../core/Auth";
import { login, getUserByToken, sendOtpData } from "../core/_requests";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocialSignup } from "../socialsignup/SocialSignup";
import { useChef } from "../../component/chef-context/chefContext";
import { loginSchema } from "../core/Schema";
import { saveFcmTokenToServer } from "../firebase/NotificationService";
const initialValues = {
  email: "",
  password: "",
};

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();
  const { setIsLoggedIn } = useChef();
  const [showAlert, setShowAlert] = useState(true);
  const navigate = useNavigate();
  const handleClose = () => {
    setShowAlert(false);
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = () => {
    // setShowPassword(!showPassword);
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);

      try {
        // Retrieve the token from localStorage

        const notificationToken = localStorage.getItem("fcmToken");
        

        const requestData = {
          email: values.email,
          password: values.password,
          notificationToken: notificationToken,
        };

        const data = await login(requestData);

        if (data?.status === true) {
          const { data: user } = await getUserByToken(data?.data.api_token);
          const userData = user?.data;
          const {
            email,
            mobileNumber,
            uuid: chefId,
            verifyOtp,
            verifyOtpEmail,
          } = userData;

          setIsLoggedIn(true);
          setLoading(false);
          const redirectUrl =
            localStorage.getItem("redirectUrl") || "/dashboard";
          const isSalesPage = localStorage.getItem("isSalesPage") === "true";

          if (isSalesPage) {
            localStorage.removeItem("isSalesPage");
            localStorage.removeItem("redirectUrl");
            navigate(redirectUrl);
          } else {
            if (!verifyOtp) {
              localStorage.setItem("chefuuid", chefId);
              localStorage.setItem("chefdata", JSON.stringify(userData));
              localStorage.setItem("logInAttempt", "true");
              
             
              navigate("/otp-device", { replace: true });
              return;
            }
            if (verifyOtp && verifyOtpEmail) {
              saveAuth(userData);
              setCurrentUser(userData);
              localStorage.setItem("manualToggle", JSON.stringify(false));
              navigate("/dashboard");
              window.location.reload();
            }
          }
          toast.success(data?.message, { autoClose: 6000 });
          await saveFcmTokenToServer({
            userId: chefId,
            userType: "chef",
            appVersion: "1.0.0",
          });
        } else {
          setStatus(
            <>
              {data?.message} <br />
              please email{" "}
              <a href="mailto:support@frayo.net">support@frayo.net</a> or{" "}
              <a onClick={handleRegister} className="link cursorPointer">
                create a new account
              </a>{" "}
              and let's come together.
            </>
          );
          setShowAlert(true);

          setLoading(false);
        }
      } catch (error) {
        saveAuth(undefined);
        setStatus(
          <>
            The login details are incorrect. For support,
            <br />
            please email{" "}
            <a href="mailto:support@frayo.net">support@frayo.net</a> or{" "}
            <a onClick={handleRegister} className="link cursorPointer">
              create a new account
            </a>{" "}
            and let's come together.
          </>
        );
        setSubmitting(false);
        setLoading(false);
        setShowAlert(true);
      }
    },
  });

  const handleRegister = () => {
    localStorage.clear();
    navigate("/signup");
  };

  return (
    <div className="container-fluid signup-sec py-3">
      <div className="row">
        <div className="col-xl-5 col-md-2 d-none d-lg-block">
          <div className="signup-img">
            <img
              src="/assets/images/signup-grid.png"
              className="img-fluid w-100"
              alt="img-grid"
            />
          </div>
        </div>

        <div className="col-xl-7 col-lg-7">
          {formik.status !== undefined && showAlert ? (
            <div
              className={`mb-lg-10 alert ${
                formik.status ? "alert-danger" : "alert-success"
              }`}
            >
              <div className="alert-text font-weight-bold">
                {formik.status}
                <button
                  className="btn p-0 close d-inline-end"
                  onClick={handleClose}
                >
                  <i className="material-symbols-outlined fs-18  px-10">
                    close
                  </i>
                </button>
              </div>
            </div>
          ) : null}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit();
            }}
            noValidate
          >
            <div className="right-form px-4 d-flex justify-content-center flex-column">
              <div className="content-sec">
                <div className="row justify-content-center">
                  <div className="col-xl-6">
                    <div className="d-flex flex-column text-center align-items-center justify-content-center">
                      <div className="login-logo mb-1">
                        <img
                          src="/assets/images/logo.svg"
                          className="img-fluid w-100"
                          alt="logo"
                        />
                      </div>
                      <h2 className="mb-2">Welcome Back! </h2>
                      <div className="row">
                        <div className="col-xl-12 text-start mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="small-font mb-2"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            {...formik.getFieldProps("email")}
                            className={clsx(
                              "form-control",
                              {
                                "is-invalid":
                                  formik.touched.email && formik.errors.email,
                              },
                              {
                                "is-valid":
                                  formik.touched.email && !formik.errors.email,
                              }
                            )}
                            id="exampleFormControlInput1"
                            placeholder="Enter your email"
                          />{" "}
                          {formik.touched.email && formik.errors.email && (
                            <div className="fv-plugins-message-container">
                              <span role="alert">{formik.errors.email}</span>
                            </div>
                          )}
                        </div>
                        <div className="col-xl-12 text-start mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="small-font mb-2"
                          >
                            Password
                          </label>
                          <div className="input-group">
                            <input
                              placeholder="Enter your password"
                              type={!showPassword ? "password" : "text"}
                              className={clsx(
                                "form-control",
                                {
                                  "is-invalid":
                                    formik.touched.password &&
                                    formik.errors.password,
                                },
                                {
                                  "is-valid":
                                    formik.touched.password &&
                                    !formik.errors.password,
                                }
                              )}
                              {...formik.getFieldProps("password")}
                            />
                            <div className="input-group-text">
                              <span
                                className="cursorPointer"
                                onClick={handleTogglePassword}
                              >
                                <i className="material-symbols-outlined">
                                  {showPassword
                                    ? "visibility"
                                    : "visibility_off"}
                                </i>
                              </span>
                            </div>
                          </div>
                          {formik.touched.password &&
                            formik.errors.password && (
                              <div className="fv-plugins-message-container">
                                <span role="alert">
                                  {formik.errors.password}
                                </span>
                              </div>
                            )}
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn primary-btn px-5 text-center mb-3 mt-2"
                        disabled={formik.isSubmitting || !formik.isValid}
                      >
                        {!loading && (
                          <span className="indicator-label">Login</span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                      <a href="/forgot-password" className="link">
                        Forgot Password?
                      </a>
                    </div>
                  </div>
                </div>

                <div className="my-3">
                  <SocialSignup />
                </div>

                <div className="row mt-0 pt-4 pb-3 footer-login">
                  <p className="text-center small-font mt-0">
                    If you don't have an account.{" "}
                    <a onClick={handleRegister} className="link cursorPointer">
                      Register
                    </a>{" "}
                    here
                  </p>

                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export { Login };
